import styled from '@emotion/styled';
import { Text, tokens } from '@hotjar/hotsauce';

export const Container = styled.div`
  padding: ${tokens.spacer.x2} ${tokens.spacer.x2} ${tokens.spacer.x3};
  background-color: ${tokens.color.neutral_100};
  border-top: 1px solid ${tokens.color.ui_border};
`;

export const StyledTileContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${tokens.spacer.x1};
`;

export const StyledText = styled(Text)`
  text-align: left;
  margin-top: ${tokens.spacer.x2};
`;
